import { useEffect } from "react";
import styles from "./toast.module.css";

type ToastProps = {
  message: string;
  onDismiss: () => void;
  duration?: number;
};

export function Toast({ message, onDismiss, duration = 5000 }: Readonly<ToastProps>) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, duration);
    return () => clearTimeout(timer);
  }, [onDismiss, duration]);

  return (
    <div className={styles.toast} data-testid="toast" role="alert">
      <div className={styles.content}>
        <div className={styles.textRow}>
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.6008 6.4225L7.60083 11.4225C7.43833 11.585 7.225 11.6667 7.01167 11.6667C6.79833 11.6667 6.585 11.585 6.4225 11.4225L4.06583 9.065C3.74 8.73917 3.74 8.21167 4.06583 7.88667C4.39083 7.56083 4.91833 7.56083 5.24417 7.88667L7.01167 9.655L11.4225 5.24417C11.7483 4.91833 12.275 4.91833 12.6008 5.24417C12.9267 5.57 12.9267 6.09667 12.6008 6.4225ZM8.33333 0C3.73083 0 0 3.73083 0 8.33333C0 12.9358 3.73083 16.6667 8.33333 16.6667C12.9358 16.6667 16.6667 12.9358 16.6667 8.33333C16.6667 3.73083 12.9358 0 8.33333 0Z" fill="#68CA92"/>
          </svg>
          <span className={styles.message}>{message}</span>
        </div>
      </div>
      <button
        type="button"
        className={styles.closeButton}
        onClick={onDismiss}
        aria-label="Fechar"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="#F2EFEF"/>
        </svg>
      </button>
    </div>
  );
}
